import React from "react";
import { checkAnimation } from "../../resources/js/gifs";
import Container from "../../shared/Container";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
const ProposalSuccess = ({ onUploadReceipt }) => {
    return (
        <div>
            <Container>
                <div className="flex flex-col items-center">
                    <P className="text-center font-vietnam">
                        Thank you for accepting our proposal,we will reach out
                        to you in next 24 hours
                    </P>

                    <img
                        src={checkAnimation}
                        className="max-h-[30rem]"
                        alt="checked"
                        loading="lazy"
                    />

                    <P className="font-vietnam text-center">
                        Pay the booking amount
                    </P>
                    <P className="font-vietnam text-center mb-1 mt-0.5 text-gray-370 text-xs lg:text-sm 2xl:text-sm">
                        Proposal will be valid for next 2-3 days
                    </P>
                    <Button className="w-full" onClick={onUploadReceipt}>
                        Upload Payment Receipt
                    </Button>
                </div>
            </Container>
        </div>
    );
};

export default ProposalSuccess;
